import http from "../http-common";

const adminAll = () => {
  return http.get(`/v1/invitations`);
};

const getAll = (loc) => {
  return http.get(`/v1/invitations/loc/${loc}`);
};

const get = (id) => {
  return http.get(`/v1/invitations/${id}`);
};

const create = (data) => {
  return http.post("/v1/invitations", data);
};

const update = (id, data) => {
  return http.put(`/v1/invitations/${id}`, data);
};

const remove = (id) => {
  return http.delete(`/v1/invitations/${id}`);
};

const removeAll = () => {
  return http.delete(`/v1/invitations`);
};

export default {
  adminAll,
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
};
